import Vue from "vue";
import Axios from "axios";
import router from "@/plugins/router";
import store from "@/store";
import { showError } from "@/helpers";
if (!document.baseAPIurl.endsWith("/")) {
  document.baseAPIurl += "/";
}

Axios.defaults.baseURL = document.baseAPIurl + "api";

var loaderTimeout = null;

Axios.interceptors.request.use(config => {
  clearTimeout(loaderTimeout);
  loaderTimeout = setTimeout(() => {
    store.dispatch("loading");
  }, 200);
  config.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");
  return config;
});

Axios.interceptors.response.use(
  response => {
    clearTimeout(loaderTimeout);
    store.dispatch("loaded");
    return response;
  },
  error => {
    clearTimeout(loaderTimeout);
    store.dispatch("loaded");
    if (error.response) {
      if (error.response.status === 400 && error.response.data.toLowerCase().includes("general error")) {
        showError("Błąd", "Wystąpił błąd podczas wykonywania akcji")
      }
      if (error.response.status === 403 || error.response.status === 401) {
        store.dispatch("logout");
        setTimeout(()=>{
          showError("Sesja wygasła", "Twoja sesja wygasła, proszę zalogować się ponownie");
        },500)
      }
    } else {
      showError("Błąd połączenia", "Wystąpił błąd podczas próby połączenia z serwerem");
    }
    return Promise.reject(error);
  }
);

Vue.$http = Axios;
Vue.prototype.$http = Axios;

export default Axios;
